import disabled from '../../secondary-button/light-gray/background/disabled';

export default disabled;
